import Layout from "@views/layout";

const communityDashboardActivityRouter = {
    path: "/dashboard/activity",
    component: Layout,
    redirect: "/dashboard/activity/activity-distribution",
    meta: {
        title: "活动看板",
        icon: "el-icon-document",
    },
    children: [
        {
            path: "activity-distribution",
            name: "COMMUNITY_DASHBOARD_ACTIVITY_ACTIVITY_DISTRIBUTION",
            component: () => import("@views/dashboard/activity/activityDistribution.vue"),
            meta: {
                title: "活动分布",
                keepAlive: false,
            },
        },
        
        {
            path: "activity-trend",
            name: "ActivityTrend",
            component: () => import("@views/dashboard/activity/ActivityTrend.vue"),
            meta: {
                title: "活动趋势",
                keepAlive: false,
            },
        },
        
        {
            path: "activity-ranking",
            name: "ActivityRanking",
            component: () => import("@views/dashboard/activity/ActivityRanking.vue"),
            meta: {
                title: "活动排行榜",
                keepAlive: false,
            },
        },
    ],
};

export default communityDashboardActivityRouter;
